import * as React from 'react';
import { ICardChecklistsProps } from './types';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { Button, ButtonDropdown, Icon, Input, LoaderBlock, SelectList, SelectListItem } from 'kui';
import {
    CARD_CHECKLIST_COPY,
    CARD_CHECKLIST_ITEM_ADD,
    CARD_CHECKLISTS_ADD,
    CARD_SECTION_CHECKLIST,
    CARD_SECTION_CHECKLISTS,
    CARD_SECTION_CHECKLISTS_MODAL_CANCEL,
    CARD_SECTION_CHECKLISTS_MODAL_REMOVE
} from './constants';
import { CLASS_CARD_DETAILS, CLASS_CARD_DETAILS_SECTION } from '../../../constants';
import './_CardChecklists.scss';
import { SettingsSection } from '../../../../../base/components/SettingsSection/SettingsSection';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import { CardChecklistHOC } from '../../hocs/CardChecklistHOC/CardChecklistHOC';
import {
    CHECKLIST_DEFAULT_ID,
    CHECKLIST_DEFAULT_NAME
} from '../../../../../../../store/model/checklists/checklists/constants';
import { TChecklistId } from '../../../../../../../types/types';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import { CardChecklistActionsHOC } from '../../hocs/CardChecklistActionsHOC/CardChecklistActionsHOC';
import { CARD_CHECKLIST_DONE, CARD_CHECKLIST_SAVE_BUTTON } from '../CardChecklist/constants';
import { IChecklistStats } from '../../../../../../../types/model';
import { getMessages, root } from '../../../../../../../store/constants';
import { ESettingsSectionType } from '../../../../../base/components/SettingsSection/types';
import { CardChecklistCopySection } from '../CardChecklistCopySection/CardChecklistCopySection';
import {
    ACTIVE_SECTION_TIMER,
    CLASS_ASIDE_PANEL_ACTIONS_BUTTON_HIGHLIGHT,
    ID_ASIDE_PANEL_ACTIONS_PORTAL
} from '../../../../asidePanel/components/AsidePanelActionsButton/constants';
import {
    EssentialUpgradeButtonHOC
} from '../../../../../base/components/EssentialUpgradeButton/hocs/EssentialUpgradeButtonHOC/EssentialUpgradeButtonHOC';
import { ActionModal } from '../../../../../base/components/ActionModal/ActionModal';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
import {
    SegmentCardChecklistCreateSourceValue
} from '../../../../../../../middlewares/segment/trackEntities/cardEvents';
import {
    CardChecklistCopySearchSelectHOC
} from '../../hocs/CardChecklistCopySearchSelectHOC/CardChecklistCopySearchSelectHOC';
import _ from 'underscore';
import { GOOGLE_SPACING } from '../../../../../../../const';
import { v4 as uuidv4 } from 'uuid';

// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardChecklists asidePanel`) : null;

export function CardChecklists ({
    aloudCount,
    checklists,
    checklistItems,
    isEmpty,
    isDefaultProperty,
    isRequired,
    isShow,
    sectionType,
    onAddNewChecklistButton,
    onChecklistAdd,
    onClose,
    onCopy,
    onDelete,
    onNameChange,
    onShowBoardLimitSnackbarIfNeeded,
    onSort
}: ICardChecklistsProps) {
    const { showedProperties, boardId, cardId, addShowedProperty, isCommentsColumn } = React.useContext(AsidePanelContext);

    if (analyzeRender) analyzeRender.call(`CardChecklists asidePanel ${cardId}`);

    const isReadonly = sectionType === ESettingsSectionType.READONLY;

    const stats: IChecklistStats = {
        checkedCount: 0,
        checkedPercent: 0,
        totalCount: 0,
        estimate: 0,
    };

    const [isLoading, setLoading] = React.useState(null);
    const [isAdding, setAdding] = React.useState(null);

    const isMultiple = checklists && checklists.length > 1 &&
        !(isLoading && !!checklists.find(({ id }) => id === CHECKLIST_DEFAULT_ID));

    if (!isMultiple && checklistItems) {
        stats.totalCount = checklistItems.length;
        let weightTotal = 0;
        let weightChecked = 0;
        checklistItems.forEach(item => {
            weightTotal += item.weight;
            if (item.checked) {
                stats.checkedCount++;
                weightChecked += item.weight;
            }
            stats.estimate += item.estimate || 0;
        });
        if (weightTotal) stats.checkedPercent = Math.round(weightChecked * 100 / weightTotal);
    }

    const className = CLASS_CARD_DETAILS + '__checklists';

    const [isShowSection, setShowSection] = React.useState(false);
    let [openedChecklistId, _setOpenedChecklistId] = React.useState(null);
    const [isAddItem, setAddItem] = React.useState(null);
    const [isDragging, setDragging] = React.useState(null);
    const [isShowDefaultChecklist, setShowDefaultChecklist] = React.useState(null);
    const [isEditing, setEditing] = React.useState(null);
    const [name, setName] = React.useState(null);
    const [copyCardId, setCopyCardId] = React.useState(null);
    const [isCopy, setCopy] = React.useState(null);
    const [isAddCopy, setAddCopy] = React.useState(null);
    const [removingId, setRemovingId] = React.useState(null);
    const [isOpened, setOpened] = React.useState(null);
    const [classUnique] = React.useState(className + '-title-add-dropdown' + '--' + uuidv4());

    const inputRef = React.useRef(null);
    const copyRef = React.useRef(null); // прятать дефолтный чеклист, если открыли пустую секцию и скопировали чеклист
    const highLightTimer = React.useRef(null);
    const timerRef = React.useRef(null);
    const doubleClick = React.useRef(null);
    const continueAddRef = React.useRef(null);

    const setOpenedChecklistId = (checklistId: TChecklistId) => {
        openedChecklistId = checklistId;
        _setOpenedChecklistId(checklistId);
    };

    const onCloseModal = () => {
        onClose();
        setRemovingId(null);
    };

    const onAdd = (source?: SegmentCardChecklistCreateSourceValue) => {
        if (isCopy) {
            onCopyClose();
        }
        setAdding(true);
        onChecklistAdd(source).then(checklistId => {
            if (checklistId) {
                setOpenedChecklistId(checklistId);
                setTimeout(() => {
                    const selector = '.' + CLASS_CARD_DETAILS_SECTION + '--checklist' + checklistId + ' .' + CLASS_CARD_DETAILS_SECTION + '__placeholder';
                    const section = document.querySelector(selector) as HTMLElement;
                    const highlighted = document.querySelector('.' + CLASS_ASIDE_PANEL_ACTIONS_BUTTON_HIGHLIGHT);
                    if (highlighted) highlighted.classList.remove(CLASS_ASIDE_PANEL_ACTIONS_BUTTON_HIGHLIGHT); // если ещё предыдущая секция подсвечивается
                    section.classList.add(CLASS_ASIDE_PANEL_ACTIONS_BUTTON_HIGHLIGHT); // подсветить секцию
                    section.scrollIntoView({ block: 'center' });

                    if (highLightTimer.current) clearTimeout(highLightTimer.current);
                    highLightTimer.current = setTimeout(() => {
                        section.classList.remove(CLASS_ASIDE_PANEL_ACTIONS_BUTTON_HIGHLIGHT); // убрать подсветку
                    }, ACTIVE_SECTION_TIMER * 2);
                }, 0);
            }
        }).finally(() => setAdding(false));
    };

    function onDragEnd(result: DropResult) {
        setDragging(false);
        if (
            !result.destination ||
            (
                result.source.droppableId === result.destination.droppableId &&
                result.destination.index === result.source.index
            )
        ) {
            // do nothing
        } else {
            onSort(
                Number(result.draggableId),
                result.destination.index,
                Number(result.source.droppableId),
                Number(result.destination.droppableId)
            );
        }
    }

    const onDragStart = () => {
        setDragging(true);
    };

    const onAddClick = () => {
        if (
            isEmpty ||
            (checklists &&
            checklists.length &&
            checklists.length === 1 &&
            checklists[0].id === CHECKLIST_DEFAULT_ID)
        ) {
            setOpenedChecklistId(openedChecklistId === CHECKLIST_DEFAULT_ID ? null : CHECKLIST_DEFAULT_ID);
            setShowDefaultChecklist(true);
        } else {
            if (continueAddRef.current) {
                continueAddRef.current = false;
                return;
            }
            setOpenedChecklistId(openedChecklistId ? null : checklists[0].id);
        }
    };

    const onHeaderClick = () => {
        onShowBoardLimitSnackbarIfNeeded();
        if (isEditing || isReadonly) return;
        if (
            isEmpty ||
            (checklists &&
                checklists.length &&
                checklists.length === 1 &&
                checklists[0].id === CHECKLIST_DEFAULT_ID)
        ) {
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(onAddClick, 500);
        } else {
            const input = document.querySelector(`.${CLASS_CARD_DETAILS}-checklist__add-input .kui-input__item`) as HTMLInputElement;
            if (input && input.value) { // применяем тут, а не в onAddClick т.к. blur инпута сработает быстрее
                setAddItem(true);
                continueAddRef.current = true;
                input.focus();
                setTimeout(() => { // сбрасываем
                    setAddItem(false);
                }, 0);
            }
            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(onAddClick, 500);
        }
    };

    const onNameClick = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        if (doubleClick.current) clearTimeout(doubleClick.current);
        onRename();
    };

    const onChange = (e: React.SyntheticEvent) => {
        const { value } = e.target as HTMLInputElement;
        setName(value);
    };

    const onSave = () => {
        setEditing(false);
        if (name && name.trim()) {
            if (!isMultiple) {
                setLoading(true);
            }
            onNameChange(name).finally(() => {
                if (!isMultiple) {
                    setLoading(false);
                }
            });
        }
    };

    const onEscape = (e: React.KeyboardEvent) => {
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            setEditing(false);
        }
    };

    const onCopyClose = () => {
        if (copyRef.current) {
            setShowDefaultChecklist(false);
        }
        setCopy(false);
        setCopyCardId(null);
    };

    const onRename = () => {
        setEditing(true);
        if (name.includes(CHECKLIST_DEFAULT_NAME) || name === CARD_SECTION_CHECKLIST) {
            setTimeout(() => {
                inputRef.current.getInput().select();
            }, 0);
        }
    };

    React.useEffect(() => { // добавлять новые чеклисты вниз списка
        setShowDefaultChecklist(false);
    }, [checklists]);

    React.useEffect(() => {
        if (!isShowSection || isLoading) return;
        setName(checklists && checklists[0] && checklists[0].name || CHECKLIST_DEFAULT_NAME);
    }, [isShowSection, checklists]);

    React.useEffect(() => {
        if (isShow || isDefaultProperty) {
            setShowSection(true);
            addShowedProperty(EAsidePanelProperty.CARD_CHECKLIST, isCommentsColumn);
        }
    }, [isShow, isDefaultProperty]);

    React.useEffect(() => {
        setCopyCardId(copyCardId);
        setCopy(!!copyCardId);
        setTimeout(() => {
            const copySection = document.querySelector('.' + CLASS_CARD_DETAILS + '__checklist-copy') as HTMLElement;
            if (copySection) {
                copySection.scrollIntoView({ block: 'center' });
            }
        }, 0);
    }, [copyCardId]);

    React.useEffect(() => {
        copyRef.current = isCopy && isEmpty;
    }, [isCopy, isEmpty]);

    React.useEffect(() => {
        const dropdown = document.querySelector(`.${classUnique}`) as HTMLElement;
        if (!dropdown) return;
        const observer = new MutationObserver(mutations => {
            const dropdownItem = document.querySelector(`.${classUnique} .kui-dropdown__item`) as HTMLElement;
            if (dropdownItem && dropdownItem.style.maxHeight) {
                const itemRect = dropdownItem.getBoundingClientRect();
                dropdownItem.style.maxHeight = root._innerHeight - itemRect.top - GOOGLE_SPACING * 3 + 'px';
                console.log(root._innerHeight - itemRect.top - GOOGLE_SPACING * 3 + 'px')
                observer.disconnect();
            }
        });
        observer.observe(dropdown, { childList: true });
        return () => {
            observer.disconnect();
        }
    }, [isOpened]);

    if (
        isEmpty && isReadonly ||
        !isShowSection && !showedProperties.has(EAsidePanelProperty.CARD_CHECKLIST)
    ) {
        return;
    }

    return (
        <SettingsSection
            className={`
                ${CLASS_CARD_DETAILS_SECTION}
                ${CLASS_CARD_DETAILS_SECTION + '--checklists'}
                ${className}
                ${isEmpty && !openedChecklistId ? className + '--empty' : ''}
                ${isReadonly ? className + '--readonly' : ''}
                ${isDragging ? className + '--drag' : ''}
                ${isEditing ? className + '--editing' : ''}
                ${isMultiple ? className + '--multiple' : ''}
                ${!isMultiple && _.isNumber(openedChecklistId) ? className + '--add' : ''}
            `}
            isRequired={isRequired}
            isRequiredError={isEmpty}
            sectionType={sectionType}
            titleSub={!isEditing && stats && !!stats.totalCount &&
                getMessages().getText(CARD_CHECKLIST_DONE, null, stats.checkedPercent, stats.checkedCount, stats.totalCount)
            }
            titleButton={
                <>
                    {isEditing && !isMultiple &&
                        <div className={className + '-name'}>
                            <Input
                                className={className + '-input'}
                                value={name}
                                autosize={false}
                                autoFocus
                                onChange={onChange}
                                onKeyDown={onEscape}
                                onEnter={onSave}
                                onBlur={onSave}
                                ref={inputRef}
                            />
                            {name &&
                                <Button
                                    className={className + '-save'}
                                    onClick={onSave}
                                >
                                    {CARD_CHECKLIST_SAVE_BUTTON}
                                </Button>
                            }
                        </div>
                    }
                    {!isReadonly &&
                        <>
                            <CardChecklistActionsHOC
                                copyCardId={copyCardId}
                                cardId={cardId}
                                checklistId={checklists && checklists[0] && checklists[0].id}
                                isMultiple
                                isEmptyChecklists={isEmpty}
                                onRename={onRename}
                                onDelete={() => onDelete(checklists && checklists[0] && checklists[0].id).then((result) => {
                                    if (!result) setRemovingId(checklists[0].id);
                                })}
                                onCopy={setCopyCardId}
                            />
                            {!isMultiple && !isEditing &&
                                <div
                                    className={className + '-header'}
                                    onClick={onHeaderClick}
                                    onDoubleClick={onNameClick}
                                />
                            }
                            <ButtonDropdown
                                className={className + '-title-add-w-actions'}
                                dropdownClassName={`
                                        ${className + '-title-add-dropdown'}
                                        ${isAddCopy ? className + '-title-add-dropdown--copy' : ''}
                                        ${classUnique}
                                    `}
                                isMoveToFit
                                directionHorizontal={'right'}
                                directionVertical={'down'}
                                disabled={!isMultiple && _.isNumber(openedChecklistId)}
                                opened={isOpened}
                                onOpen={() => setOpened(true)}
                                onClose={() => {
                                    setOpened(false);
                                    setAddCopy(false);
                                }}
                                portal
                                portalId={ID_ASIDE_PANEL_ACTIONS_PORTAL}
                            >
                                <Button
                                    className={className + '-title-add'}
                                    variant={'icon'}
                                >
                                    <Icon className={className + '-title-add-plus'} size={24} xlink={'plus-circle'}/>
                                    <Icon className={className + '-title-add-close'} size={24} xlink={'close'}/>
                                </Button>
                                <>
                                    {isAddCopy ?
                                        <CardChecklistCopySearchSelectHOC
                                            boardId={boardId}
                                            cardId={cardId}
                                            selectedCardId={copyCardId}
                                            isAutoFocus
                                            isClose
                                            onSelect={cardId => {
                                                onCopy();
                                                setCopyCardId(cardId);
                                                setOpened(false);
                                            }}
                                        />
                                        : <SelectList fixActive={false}>
                                            {!isMultiple &&
                                                <SelectListItem
                                                    icon={'plus'}
                                                    iconSize={24}
                                                    onClick={() => {
                                                        setOpened(false);
                                                        onAddClick();
                                                    }}
                                                >
                                                    {CARD_CHECKLIST_ITEM_ADD}
                                                </SelectListItem>
                                            }
                                            <SelectListItem
                                                icon={'checklist-add-items'}
                                                iconSize={24}
                                                onClick={() => {
                                                    setOpened(false);
                                                    onAdd(SegmentCardChecklistCreateSourceValue.MENU);
                                                }}
                                            >
                                                {CARD_CHECKLISTS_ADD}
                                            </SelectListItem>
                                            <SelectListItem
                                                icon={'copy'}
                                                iconSize={24}
                                                onClick={() => {
                                                    setAddCopy(true);
                                                }}
                                            >
                                                {CARD_CHECKLIST_COPY}
                                            </SelectListItem>
                                        </SelectList>
                                    }
                                </>
                            </ButtonDropdown>
                        </>
                    }
                </>
            }
            title={isMultiple ? CARD_SECTION_CHECKLISTS
                : isEmpty ? CARD_SECTION_CHECKLIST
                    : checklists[0] || checklists && checklists.length > 1 &&
                    isLoading && !!checklists.find(({ id }) => id === CHECKLIST_DEFAULT_ID) ? name
                        : CARD_SECTION_CHECKLIST
            }
            isTitleTooltip={!isEditing}
        >
            <DragDropContext
                onDragStart={onDragStart}
                onDragEnd={onDragEnd}
            >
                {isLoading && <LoaderBlock />}
                {
                    (!isEmpty || _.isNumber(openedChecklistId)) && checklists.map((checklist, index) => {
                        const { id } = checklist;
                        if (
                            id === CHECKLIST_DEFAULT_ID &&
                            (
                                !isShowDefaultChecklist &&
                                !isEmpty &&
                                checklists.length > 1 &&
                                !(
                                    checklistItems &&
                                    checklistItems[0] &&
                                    checklistItems[0].checklistId === CHECKLIST_DEFAULT_ID
                                ) ||
                                isLoading ||
                                (checklists.length > 1 && isAdding)
                            )
                        ) {
                            return;
                        }
                        return (
                            <CardChecklistHOC
                                onDelete={() => onDelete(id).then((result) => {
                                    if (!result) setRemovingId(id);
                                })}
                                onAddOpen={() => setOpenedChecklistId(id)}
                                isAddItem={isAddItem}
                                isSingle={!isMultiple}
                                isOpened={openedChecklistId === id}
                                boardId={boardId}
                                cardId={cardId}
                                checklistId={id}
                                onAddClose={() => {
                                    setOpenedChecklistId(null);
                                }}
                                key={`${id}i${index}`} // checklist.id может не быть в сторе, пока не загрузится карта, если чеклист прилетел из риалтайм
                            />
                        );
                    })
                }
            </DragDropContext>
            {isCopy &&
                <CardChecklistCopySection
                    onClose={onCopyClose}
                    onCancel={onAdd}
                    selectedCardId={copyCardId}
                    setSelectedCardId={setCopyCardId}
                />
            }
            <ActionModal
                isShow={!!removingId}
                actions={[
                    {
                        variant: 'primary',
                        onClick: onCloseModal,
                        children: CARD_SECTION_CHECKLISTS_MODAL_CANCEL
                    },
                    {
                        variant: 'secondary',
                        onClick: () => {
                            onCloseModal();
                            return onDelete(removingId);
                        },
                        children: CARD_SECTION_CHECKLISTS_MODAL_REMOVE
                    },
                ]}
                footer={<EssentialUpgradeButtonHOC onClick={onCloseModal} />}
                text={getMessages().getText('card_form_section_checklists_modal_text', null, aloudCount)}
                title={getMessages().getText('card_form_section_checklists_modal_title', null, checklists?.find(checklist => checklist.id === removingId)?.name)}
                onClose={onCloseModal}
            />
        </SettingsSection>
    );
};
